import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  surgeryId: string;
  patientId: string;
}

export const useDeleteSurgicalRecord = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ surgeryId }: MutationProps) => {
      return api.delete(`patient/surgical/${surgeryId}`);
    },

    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "delete-surgical-record-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.surgery(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Surgical Record]", res);

      handleErrors(res, "mutation");
    },
  });
};
